import { Languages } from "../../enums/languages";

const footerLang = {
    "line-1": {
        [Languages.Hebrew]: { default: "לבירור ותמיכה ניתן להתקשר לחברת לולהטק בטלפון: 077-7944440 שלוחה 1 בין השעות: 09:00-17:00." },
        [Languages.Arabic]: { default: "للاستفسار والدعم، يمكن الاتصال بشركة لولا تك على الرقم: 077-7944440 تحويلة 1 بين الساعة: 09:00-17:00." },
        [Languages.English]: { default: "For inquiries and support, you can contact Lolatech at: 077-7944440 Extension 1 between the hours: 09:00-17:00." },
    },
    "line-2": {
        [Languages.Hebrew]: { default: "כתובתנו רחוב יצחק שדה 8, תל אביב מיקוד:6777855." },
        [Languages.Arabic]: { default: "عنواننا: شارع يشاك شادة 8، تل أبيب، الرمز البريدي: 6777855." },
        [Languages.English]: { default: "Our address: 8 Yitzhak Sadeh Street, Tel Aviv, ZIP: 6777855." },
    },
    "line-3": {
        [Languages.Hebrew]: { default: "כל הזכויות שמורות ללולהטק בע\"מ" },
        [Languages.Arabic]: { default: "جميع الحقوق محفوظة لشركة لولا تك المحدودة" },

        [Languages.English]: { default: "All rights reserved to Lolatech Ltd." },
    },
    "privacyPolicy": {
        [Languages.Hebrew]: { default: "מדיניות פרטיות" },
        [Languages.Arabic]: { default: "سياسة الخصوصية" },
        [Languages.English]: { default: "Privacy Policy" },
    },
    "accessibilityStatement": {
        "long": {
            [Languages.Hebrew]: { default: "הצהרת נגישות" },
            [Languages.Arabic]: { default: "بيان الوصول" },
            [Languages.English]: { default: "Accessibility Statement" },
        },
        "short": {
            [Languages.Hebrew]: { default: "הצהרת נגישות" },
            [Languages.Arabic]: { default: "بيان الوصول" },
            [Languages.English]: { default: "Accessibility Stat" },
        }
    },
    "portal-header-title-tag": {
        [Languages.Hebrew]: { default: "פורטל תווים" },
        [Languages.Arabic]: { default: "بوابة تذكرة وقوف السيارات" },
        [Languages.English]: { default: "Permit Portal" },
    },
}

export default footerLang;